'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { useInertProps } from '../../hooks/use-inert-props';
import { LoadingMaskRootContext } from './context/loading-mask-root.context';
import { loadingMaskContentRecipe } from './styles/loading-mask-content.styles';
import type { LoadingMaskContentPropsInterface } from './types/loading-mask-content.types';

export const LoadingMaskContent = forwardRef<HTMLDivElement, LoadingMaskContentPropsInterface>(
  (props: LoadingMaskContentPropsInterface, forwardedRef) => {
    const { css: cssProp, className, loading = true, onImpact = false, inert, ...rest } = props;

    const context = useContext(LoadingMaskRootContext);

    const styles = css(
      loadingMaskContentRecipe.raw({
        loading: context.loading ?? loading,
        onImpact: context.onImpact ?? onImpact,
      }),
      cssProp,
    );

    const inertProps = useInertProps(inert ?? context.loading ?? loading);

    return (
      <div
        className={cx('c11n', styles, className)}
        data-c11n-component="LoadingMask.Content"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...inertProps}
        {...rest}
      />
    );
  },
);

LoadingMaskContent.displayName = 'LoadingMask.Content';
